export default {
	TABLE_TITLE: 'Nutrition values',
};
